import { Button, ButtonTheme } from '@apply/components';
import { UserModal } from '../../../../../../../UserModal/UserModal';
import { useGCUserModal } from '../../../../../../../../hooks/useGCUserModal';
import LoadPanel from 'devextreme-react/load-panel';
import '../../../../../../../../scss/_byUserPanel.scss';

export interface EditUserButtonProps {
    authorizedDrawUserId: number;
    onRefresh: () => void;
    onClose?: () => void;
}

export const EditUserButton: React.FC<EditUserButtonProps> = ({ authorizedDrawUserId, onRefresh, onClose }) => {
    const modal = useGCUserModal(onRefresh);

    const handleClick = () => {
        modal.loadAndOpen(authorizedDrawUserId);
        onClose?.();
    };

    return (
        <>
            <Button
                id={`gcEditButton_${authorizedDrawUserId}`}
                theme={ButtonTheme.LinkBlue}
                height='15px'
                handleClick={handleClick}
            >
                Edit
            </Button>
            <LoadPanel
                hideOnOutsideClick={false}
                visible={modal.isLoading}
                message='Loading user...'
            />
            <UserModal
                isOpen={modal.isOpen}
                onSubmitAsync={modal.onSubmitAsync}
                onClose={modal.close}
                authorizedDrawUser={modal.authorizedDrawUser}
            />
        </>
    );
};
